var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import FoodIcon from '@material-ui/icons/EmojiFoodBeverageOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import HotelIcon from '@material-ui/icons/LocationCity';
import UndoIcon from '@material-ui/icons/Replay';
import AccmmdIcon from '@material-ui/icons/TripOrigin';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { fetchTourAvailabilityApprox } from 'api-ito/ToursApi';
import { _T } from 'appI18n';
import TourAvailabilityDatePicker from 'react-components/AvailabilityDatePicker';
import { BackdropContext } from 'react-components/BackdropProvider';
import Rating from 'react-components/Rating';
import LoginToSeePricesButton from 'react-components/LoginToSeePricesButton';
import { TouristPickerDialog, TouristPickerTextField } from 'react-components/TouristPicker';
import { formatMoney, pluralizeAutoSplit } from 'utils';
import { useTourDescription, useTourExtras, useTourVariant, useViewConfig } from '../../../TourSearch/store/TourDescriptionStore';
import { _ParentFrame } from '../../../Frame/types/Frame';
import { useLocation } from 'react-router-dom';
import { ReplaceCartTourDialog } from '../../../NewTourSearch/compoments/TourSearch';
const useStyles = makeStyles(theme => ({
    root: {},
    sidebar: {
    //paddingLeft: theme.spacing(1),
    //paddingRight: theme.spacing(1),
    },
    prop: {
        borderBottom: '1px solid #eee',
        margin: '4px 0',
        padding: '4px 0',
        // FIXME: hardcoded color.
        color: '#32363a',
    },
    propIcon: {
        paddingRight: theme.spacing(0.5),
    },
    propTitle: {
        display: 'flex',
    },
    iconSuccess: {
        color: theme.palette.success.main,
    },
    iconWarn: {
        color: theme.palette.warning.main,
    },
    price: {},
    bookBtn: {
        padding: '8px 0',
        borderRadius: 0,
        fontWeight: 600,
        fontSize: '1.025rem',
    },
    featuresContainer: {
        position: 'relative',
    },
    featuresOverlay: {
        display: 'flex',
        background: 'rgba(255,255,255,80%)',
        backdropFilter: 'blur(5px)',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 24,
    },
}));
const useConfigurablesStyles = makeStyles(theme => ({
    root: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    label: {
        fontWeight: 600,
        color: `${theme.palette.text.secondary} !important`,
    },
    datepickerContainer: {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        position: 'relative',
    },
    iconError: {
        color: theme.palette.error.main,
    },
}));
function TourFeatures({ tourVariant, accmmdVariant, hotelDescription }) {
    var _a;
    const classes = useStyles();
    return (React.createElement("div", null,
        React.createElement(TourFeature, { title: _T.COMMON_HOTEL, icon: React.createElement(HotelIcon, null) },
            React.createElement(Typography, { variant: "h6" }, accmmdVariant.hotelName),
            React.createElement(Rating, { rating: (_a = hotelDescription.starRating) !== null && _a !== void 0 ? _a : 0 }),
            React.createElement("br", null),
            accmmdVariant.cityName,
            ", ",
            accmmdVariant.countryName),
        React.createElement(TourFeature, { title: _T.COMMON_ROOM_CATEGORY, icon: React.createElement(AccmmdIcon, null) },
            accmmdVariant.roomTypeName,
            ", ",
            accmmdVariant.roomCategoryName),
        React.createElement(TourFeature, { title: _T.COMMON_MEAL, icon: React.createElement(FoodIcon, null) }, accmmdVariant.mealTypeName),
        React.createElement(TourFeature, { title: _T.COMMON_AVAILABILITY, icon: accmmdVariant.immediateConfirm
                ? React.createElement(CheckCircleOutlinedIcon, { className: classes.iconSuccess })
                : React.createElement(ContactSupportOutlinedIcon, { className: classes.iconWarn }) }, accmmdVariant.immediateConfirm ? _T.TOUR_AVAILABLE : _T.TOUR_ONREQUEST)));
}
function TourFeature({ title, icon, children }) {
    const classes = useStyles();
    return React.createElement(Grid, { container: true, spacing: 1, className: classes.prop },
        React.createElement(Grid, { item: true, xs: 4, className: classes.propTitle },
            React.createElement("span", { className: classes.propIcon }, icon),
            " ",
            title),
        React.createElement(Grid, { item: true, xs: 8, className: "tour-prop-value" }, children));
}
function Configurables(props) {
    const classes = useConfigurablesStyles();
    const [touristPickerOpen, setTouristPickerOpen] = useState(false);
    const maxDate = useMemo(() => moment().add(1, 'year').day(31).format('YYYY-MM-DD'), []);
    const datepickerInputProps = useMemo(() => ({ borderless: true }), []);
    const datepickerLabelProps = useMemo(() => ({ className: classes.label }), []);
    const handleDateAndDurationChanged = (dateIso, duration) => dateIso && props.onChange(dateIso, duration !== null && duration !== void 0 ? duration : props.duration, props.adultCount, props.childAges);
    const handleTouristsChanged = (ac, ca) => props.onChange(props.date, props.duration, ac, ca);
    const loadAvailability = (monthIso) => __awaiter(this, void 0, void 0, function* () {
        const result = yield fetchTourAvailabilityApprox(props.tourId, monthIso);
        if ('errors' in result) {
            console.error('Unable to load availabilities', result.errors, monthIso);
            return [];
        }
        return result;
    });
    return (React.createElement(Grid, { container: true, className: classes.root },
        React.createElement(Grid, { item: true, xs: 12, className: classes.datepickerContainer },
            React.createElement(TourAvailabilityDatePicker, { calendarLabel: _T.TOUR_START_DATE, fieldLabel: _T.TOUR_DATE, labelFunc: props.datepickerLabelFunc, labelProps: datepickerLabelProps, inputProps: datepickerInputProps, date: props.date, maxDate: maxDate, adornment: !props.date ? React.createElement(ErrorIcon, { className: classes.iconError }) : null, onChange: handleDateAndDurationChanged, onAvailabilityRequested: loadAvailability, fullWidth: true, isFrame: props.isFrame, withDuration: true, duration: props.duration })),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(TouristPickerTextField, { adultCount: props.adultCount, childAges: props.childAges, onClick: () => {
                    const parentFrame = _ParentFrame();
                    if (props.isFrame && parentFrame) {
                        parentFrame.sendMessage({ message: 'open-modal', });
                    }
                    setTouristPickerOpen(true);
                }, labelProps: datepickerLabelProps, fullWidth: true, borderless: true }),
            touristPickerOpen &&
                React.createElement(TouristPickerDialog, { open: touristPickerOpen, adultCount: props.adultCount, childAges: props.childAges, onChange: handleTouristsChanged, onClose: () => {
                        setTouristPickerOpen(false);
                        const parentFrame = _ParentFrame();
                        if (props.isFrame && parentFrame) {
                            parentFrame.sendMessage({ message: 'close-modal', });
                        }
                    }, isFrame: props.isFrame }) || null)));
}
function NotAvailableError(props) {
    return (React.createElement(Alert, { severity: "error" },
        React.createElement(AlertTitle, null, _T.TOUR_ERROR_DATE_UNAVAIL_TITLE),
        _T.TOUR_ERROR_DATE_UNAVAIL_BODY,
        props.showCancelButton &&
            React.createElement(Box, { mt: 1 },
                React.createElement(Button, { size: "small", color: "primary", variant: "contained", disableElevation: true, onClick: props.onClickCancel },
                    React.createElement(UndoIcon, { fontSize: "small" }),
                    " ",
                    _T.COMMON_ACTION_CANCEL)) || null));
}
function BookButton({ onClick, label, disabled }) {
    const classes = useStyles();
    return (React.createElement(Button, { color: "primary", variant: "contained", className: classes.bookBtn, fullWidth: true, disableElevation: true, onClick: onClick, disabled: disabled || false }, label));
}
function TourSidebarImpl(props) {
    var _a;
    const classes = useStyles();
    const location = useLocation();
    const backdrop = useContext(BackdropContext);
    const [{ tourDescription, excursionServices, flightServices, externalFlight, separaretedSelectedExternalFlights, hotelServices, hash }, actions] = useTourDescription(null, props.isFrame);
    const [{ tourVariant, currentAccommodationVariants, loading, errors, totalVariantPrice }] = useTourVariant(props.isFrame);
    const [{ extras, price }] = useTourExtras(props.isFrame);
    const excursionServicesString = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}__${e.beginDate}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "", [excursionServices]);
    const [adultCount, setAdultCount] = useState(tourVariant && tourVariant.adultCount || 2);
    const [childAges, setChildAges] = useState((tourVariant === null || tourVariant === void 0 ? void 0 : tourVariant.childAges) || []);
    const [[date, duration], setDate] = useState([(tourVariant === null || tourVariant === void 0 ? void 0 : tourVariant.checkInDate) || null, (tourVariant === null || tourVariant === void 0 ? void 0 : tourVariant.duration) || null]);
    //const [date, setDate] = useState(tourVariant?.checkInDate || null);
    //// TODO
    //const [duration, setDuration] = useState(tourVariant?.duration || 0);
    // Дата на которую тур оказался недоступен.
    const [unavailableDate, setUnavailableDate] = useState(null);
    const [showError, setShowError] = useState(false);
    const labelFunc = useCallback(() => {
        if (!tourVariant)
            return date ? moment(date).format('L') + (duration ? `, ${duration} ${pluralizeAutoSplit(duration, _T.COMMON_NIGHTS_PLURAL)}` : '') : _T.TOUR_CHOOSE_TOUR_DATE;
        //const duration = Math.max(0, tourDescription.durationDays);
        const daysPlural = pluralizeAutoSplit(tourVariant.duration, _T.COMMON_NIGHTS_PLURAL);
        const from = moment(tourVariant.checkInDate);
        const to = from.clone().add(tourVariant.duration, 'days');
        return `${from.format('L')} — ${to.format('L')}, ${duration} ${daysPlural}`;
    }, [tourVariant, tourDescription, date, duration]);
    const handleRevertParams = () => {
        setShowError(false);
        if (tourVariant) {
            setDate([tourVariant.checkInDate, tourVariant.duration]);
            //setDuration(tourVariant.duration);
            setAdultCount(tourVariant.adultCount);
            setChildAges(tourVariant.childAges);
        }
    };
    const handleApplyParamsClicked = () => {
        if (!date || !duration || loading)
            return;
        const momentDate = moment(date);
        //if (tourVariant &&
        //    tourVariant.adultCount == adultCount &&
        //    tourVariant.childAges.join(' ') == childAges.join(' ') &&
        //    moment(tourVariant.checkInDate).format('YYYYMMDD') == momentDate.format('YYYYMMDD')) {
        //    setShowError(false);
        //    return;
        //}
        setUnavailableDate(null);
        actions.setBookingParams({
            date: moment(date),
            duration: duration,
            tourists: { adultCount, childAges },
            handlers: {
                onTourUnavailable: (_variant) => {
                    setUnavailableDate(moment(_variant.checkInDate));
                },
                onFinished: (params) => {
                    setUnavailableDate(null);
                    setDate([params.date, params.duration]);
                    setAdultCount(params.tourists.adultCount);
                    setChildAges(params.tourists.childAges);
                },
            }
        });
    };
    const handleTourParameterChange = (dateIso, duration, adultCount, childAges) => {
        setDate([dateIso, duration]);
        //setDuration(duration);
        setAdultCount(adultCount);
        setChildAges(childAges);
    };
    useEffect(() => {
        if (tourVariant && hash)
            handleApplyParamsClicked();
    }, [date, duration, adultCount, childAges]);
    useEffect(() => {
        const showError = !loading && (errors.length || unavailableDate);
        setShowError(!!showError);
    }, [errors, unavailableDate, loading]);
    const handleBookClicked = (replaceExistingTour) => {
        if (!tourVariant)
            return;
        backdrop.show();
        actions.book(replaceExistingTour).then((errors) => {
            if (errors === null || errors === void 0 ? void 0 : errors.length) {
                if (errors.includes("CART_CONFLICT_SERVICE") || errors.includes("CART_CONFLICT_CURRENCY")) {
                    const reason = errors.includes("CART_CONFLICT_CURRENCY") ? "currency" : "service";
                    const showModal = window.showCartConflictModal;
                    if (showModal) {
                        showModal({
                            reason,
                            onReplace: () => actions.book(replaceExistingTour, true),
                        });
                        backdrop.hide();
                        return;
                    }
                }
                if (errors[0] == "CART_ALREADY_CONTAINS_OTHER_TOUR")
                    setReplaceCartTourDialogOpen(true);
                backdrop.hide();
            }
            else {
                if (props.bookCallback)
                    props.bookCallback();
                backdrop.hide();
            }
        }).catch(() => backdrop.hide());
    };
    useEffect(() => {
        if (!props.isFrame)
            return;
        const params = new URLSearchParams(location.search);
        if (params.get('cartOpen') != "true")
            return;
        handleBookClicked(false);
    }, [tourVariant]);
    const fullPrice = useMemo(() => actions.getTourCost(), [extras, hash, price === null || price === void 0 ? void 0 : price.services, price === null || price === void 0 ? void 0 : price.defaultAirServices, price === null || price === void 0 ? void 0 : price.mandatoryExtras, externalFlight, separaretedSelectedExternalFlights, excursionServicesString]);
    const [replaceCartTourDialogOpen, setReplaceCartTourDialogOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { className: `${classes.sidebar} ${((_a = props.classes) === null || _a === void 0 ? void 0 : _a.root) || ''}`, elevation: 0 },
            React.createElement(Box, { mb: 2 },
                React.createElement(Configurables, { tourId: tourDescription.id, date: date, duration: duration, adultCount: adultCount, childAges: childAges, datepickerLabelFunc: labelFunc, onChange: handleTourParameterChange, isFrame: props.isFrame })),
            tourVariant && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.featuresContainer },
                    currentAccommodationVariants.map((currentAccommodationVariant, index) => (React.createElement(Fragment, { key: index }, (currentAccommodationVariant === null || currentAccommodationVariant === void 0 ? void 0 : currentAccommodationVariant.accommodation) &&
                        React.createElement(Box, { mb: 2 },
                            React.createElement(TourFeatures, { tourVariant: tourVariant, accmmdVariant: currentAccommodationVariant.accommodation, hotelDescription: currentAccommodationVariant.hotelDescription })) || null))),
                    React.createElement(Box, { mb: 2 },
                        React.createElement(Grid, { container: true, justify: "space-between", alignItems: "center" },
                            React.createElement(Grid, { item: true, xs: "auto" },
                                React.createElement(Typography, { variant: "h4", component: "div", className: classes.price },
                                    formatMoney(fullPrice.total, { localeAware: true, currency: fullPrice.currencyDisplayName }),
                                    " ",
                                    React.createElement(Typography, { variant: "h5", component: "span" }, fullPrice.currencyDisplayName))),
                            React.createElement(Grid, { item: true, xs: "auto" }, (price === null || price === void 0 ? void 0 : price.promoProgramName) ?
                                React.createElement("span", { title: price.promoProgramName, className: "promo-highlight-cart" },
                                    "\u00A0PROMO\u00A0",
                                    React.createElement("i", { className: "fa fa-tag opacity-80", "aria-hidden": "true" }),
                                    "\u00A0") : null))),
                    loading &&
                        React.createElement("div", { className: classes.featuresOverlay },
                            React.createElement(CircularProgress, { variant: "indeterminate" })) || null,
                    showError &&
                        React.createElement("div", { className: classes.featuresOverlay },
                            React.createElement(NotAvailableError, { showCancelButton: true, onClickCancel: handleRevertParams })) || null))) || null,
            !tourVariant && showError &&
                React.createElement(Box, { mb: 1 },
                    React.createElement(NotAvailableError, null)) || null,
            !tourVariant && !showError &&
                React.createElement(Box, { mb: 1 },
                    React.createElement(Alert, { severity: "info" }, _T.TOUR_CHOOSE_TOUR_PARAMETERS)) || null,
            tourVariant &&
                React.createElement(BookButton, { label: _T.COMMON_BOOK, onClick: () => handleBookClicked(false), disabled: loading || showError }) || null,
            !tourVariant &&
                React.createElement(BookButton, { onClick: handleApplyParamsClicked, disabled: !date, label: React.createElement(React.Fragment, null,
                        _T.COMMON_SEARCH,
                        " ",
                        loading &&
                            React.createElement(Box, { display: "inline-flex", pl: 1 },
                                React.createElement(CircularProgress, { variant: "indeterminate", color: "#fff", size: 16 })) || null) }) || null),
        price
            ? React.createElement(ReplaceCartTourDialog, { price: price, open: replaceCartTourDialogOpen, onClose: () => setReplaceCartTourDialogOpen(false), onCancel: () => setReplaceCartTourDialogOpen(false), onApprove: p => {
                    handleBookClicked(true);
                    setTimeout(() => setReplaceCartTourDialogOpen(false), 200);
                } }) : null));
}
export default function TourSidebar(props) {
    var _a;
    const classes = useStyles();
    const [{ hidePrices }] = useViewConfig(props.isFrame);
    return (React.createElement(Paper, { className: `${classes.sidebar} ${((_a = props.classes) === null || _a === void 0 ? void 0 : _a.root) || ''}`, elevation: 0 }, !hidePrices
        ? React.createElement(TourSidebarImpl, Object.assign({}, props))
        : React.createElement(LoginToSeePricesButton, null)));
}
